<template>
  <RevCard
    class="mt-32 h-full p-24 md:col-span-3 md:mt-0 md:p-32 lg:col-span-9"
  >
    <h2 class="heading-2">
      {{ texts.title }}
    </h2>

    <div
      v-for="{ title, text } in texts.paragraphs"
      :key="title"
      class="mt-24 flex flex-col"
    >
      <span class="body-1-bold">
        {{ title }}
      </span>
      <span class="body-2 mt-4">
        {{ text }}
      </span>
    </div>

    <RevInfoBlock
      v-if="canOpenNewMarkets"
      class="mt-24"
      :icon="IconContact"
      :title="i18n(translations.openNewMarket)"
      variant="default"
    />
  </RevCard>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCard } from '@ds/components/Card'
import { RevInfoBlock } from '@ds/components/InfoBlock'
import { IconContact } from '@ds/icons/IconContact'

import translations from './OpenMarkets.translations'

const i18n = useI18n()

const props = defineProps<{
  hasPotentialMarkets: boolean
  canOpenNewMarkets: boolean
}>()

const textWithPotentialMarkets = {
  title: i18n(translations.openNewMarketsInMinutes),
  paragraphs: [
    {
      title: i18n(translations.moreMarketsMoreMoneyTitle),
      text: i18n(translations.moreMarketsMoreMoneyText),
    },
    {
      title: i18n(translations.easyProcessTitle),
      text: i18n(translations.easyProcessText),
    },
    {
      title: i18n(translations.automaticRulesTitle),
      text: i18n(translations.automaticRulesText),
    },
  ],
}

const textWithoutPotentialMarkets = {
  title: i18n(translations.whatsNext),
  paragraphs: [
    {
      title: i18n(translations.diversificationTitle),
      text: i18n(translations.diversificationText),
    },
    {
      title: i18n(translations.waitingNewMarketsTitle),
      text: i18n(translations.waitingNewMarketsText),
    },
    {
      title: i18n(translations.optimizeWithBackMarketServicesTitle),
      text: i18n(translations.optimizeWithBackMarketServicesText),
    },
  ],
}

const texts = props.hasPotentialMarkets
  ? textWithPotentialMarkets
  : textWithoutPotentialMarkets
</script>
